// extracted by mini-css-extract-plugin
export default {"row":"EqXM5NIWXpalF9203Lpn","column":"qmO_I29KvyJbubxJvLpp","moduleFormBlock":"SocuApzzOri7bQEU8Omg"};